export default "https://cdn.questicon.mathletics.com/assets/images/worked-solution-76d4f2c4146e03c06d20eeccc353daf3.svg";